// extracted by mini-css-extract-plugin
export default {"container":"ChannelsList_container__LWtlO","channel":"ChannelsList_channel__OvJ6t"};